import React from 'react';
import { Product } from '../utils/products';
import { Button } from './ui/Button';
import { useCart } from '../context/CartContext';
import { Link } from 'react-router-dom';
import { ShoppingCart, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProductCard({
  product
}: {
  product: Product;
}) {
  const {
    addToCart
  } = useCart();
  const categoryColors = {
    unit: 'from-[#FF6B35] to-[#FFA500]',
    kit: 'from-[#3B82F6] to-[#2563EB]',
    part: 'from-[#10B981] to-[#059669]'
  };
  return <motion.div whileHover={{
    y: -8
  }} transition={{
    duration: 0.3
  }} className="group bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl overflow-hidden border border-gray-800 hover:border-gray-700 transition-all duration-300 flex flex-col h-full" data-id="element-151">
      <Link to={`/product/${product.id}`} className="relative overflow-hidden bg-gray-950 aspect-square" data-id="element-152">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-153" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-154" />
        <div className={`absolute top-4 left-4 px-3 py-1 rounded-full bg-gradient-to-r ${categoryColors[product.category]} text-white text-xs font-bold uppercase`} data-id="element-155">
          {product.category}
        </div>
      </Link>

      <div className="p-6 flex flex-col flex-grow" data-id="element-156">
        <Link to={`/product/${product.id}`} data-id="element-157">
          <h3 className="text-xl font-bold text-white mb-2 group-hover:text-[#FF6B35] transition-colors line-clamp-2" data-id="element-158">
            {product.name}
          </h3>
        </Link>

        <p className="text-gray-400 text-sm mb-4 line-clamp-2 flex-grow" data-id="element-159">
          {product.description}
        </p>

        <div className="flex items-center justify-between pt-4 border-t border-gray-800" data-id="element-160">
          <div data-id="element-161">
            <div className="text-2xl font-black text-white" data-id="element-162">
              ${product.price}
            </div>
          </div>
          <div className="flex gap-2" data-id="element-163">
            <Button onClick={() => addToCart(product)} size="sm" className="bg-gradient-to-r from-[#FF6B35] to-[#FFA500] hover:from-[#FFA500] hover:to-[#FF6B35] text-white border-0" data-id="element-164">
              <ShoppingCart size={16} data-id="element-165" />
            </Button>
            <Link to={`/product/${product.id}`} data-id="element-166">
              <Button size="sm" variant="outline" className="border-gray-700 text-gray-300 hover:bg-gray-800" data-id="element-167">
                <ArrowRight size={16} data-id="element-168" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </motion.div>;
}